const CustomIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="1"
      viewBox="0 0 24 24"
      style={{
        backgroundColor: "#FFFFFF",
        marginLeft: "15px",
        position: "absolute",
        bottom: "0",
      }}
    >
      <path d="M12 20h9"></path>
    </svg>
  );
};

export default CustomIcon;
